import React from 'react';
import {
    FormattedDate,
} from "react-intl";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {withStyles} from "@material-ui/core/styles/index";
import i18n from "../../i18n";
import ListItem from "@material-ui/core/ListItem/ListItem";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import TowLine from '../Text/TwoLine';
import FormaterDate from '../Formater/Date';
import Icon from '@material-ui/core/Icon';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import LongTextButton from '../Text/LongTextButton';

const formatRRule = (value) =>
    (
        <React.Fragment>
            <div>
                {value.years > 0 && i18n.get('attribute.next_interval_years',
                    {
                        "count": value.years
                    })}
            </div>
            <div>
                {value.months > 0 && i18n.get('attribute.next_interval_months',
                    {
                        "count": value.months
                    })}
            </div>
        </React.Fragment>
    );


const format = (key, value) => {
    if ( value === 'check:on') {
        return (<Icon>check</Icon>);
    } else if ( value === 'check:off') {
        return (<Icon>crop_din</Icon>);
    } else if ( key === 'rrule' ) {
        return formatRRule(value);
    } else if ( value && value.length > 200 ) {
        return (<LongTextButton long={value} short={value.substr(0,200)+'...'}/>);
    }
    return value;
};

const renderDetailsRow = (label, key, valueOld, valueNew, classes) => {
    return (
        <ListItem key={key} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={6}>
                    <Typography className={classes.detailsLabel} component={"div"}
                                variant={"subtitle2"}>{label}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography className={classes.detailsValue} component={"div"}
                                variant={"body2"}>{format(key, valueOld)}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography className={classes.detailsValue} component={"div"}
                                variant={"body2"}>{format(key, valueNew)}</Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};

const HistoryListItem = ({classes, history}) => (
    <TableRow>
        <TableCell>{history.note}</TableCell>
        <TableCell>
            <TowLine
                main={history.user}
                sub={history.created_at && (<FormaterDate value={history.created_at} />)}
            />
        </TableCell>
        <TableCell>
            {history.changes && history.changes.map((history_changes) => (
                <React.Fragment key={history_changes.key}>
                    {renderDetailsRow(i18n.get(history_changes.lang, history_changes.langparams),
                        history_changes.key,
                        history_changes.from,
                        history_changes.to,
                        classes)
                    }
                </React.Fragment>
            ))}
        </TableCell>
    </TableRow>
);

const styles = theme => ({
    small: {
        color: theme.colors.lightGreyBlue,
    },
    detailsLabel: {
    },
});

export default withStyles(styles)(HistoryListItem);
